import { getToApi, postToApi } from './axios';

const qs = (params) => {
  const sp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') sp.append(k, v);
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
};

export const listEnviosCorreo = (params) => getToApi(`/envios-correo${qs(params)}`);
export const getEnvioCorreo = (id) => getToApi(`/envios-correo/${id}`);
export const resumenEnviosCorreo = (params) => getToApi(`/envios-correo/resumen${qs(params)}`);
export const reintentarEnvioCorreo = (id) =>
  postToApi(`/envios-correo/${id}/reintentar`, {}).then((r) => r.data);

// Vista del super administrador: mismos datos sin filtro de organización.
export const listEnviosCorreoGlobal = (params) => getToApi(`/liftlogic/envios-correo${qs(params)}`);
export const resumenEnviosCorreoGlobal = (params) =>
  getToApi(`/liftlogic/envios-correo/resumen${qs(params)}`);
